// extracted by mini-css-extract-plugin
export default {"AppContainer":"AppContainer_AppContainer__hiVSb"};